"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Styles = (0, _styledComponents.createGlobalStyle)(_templateObject || (_templateObject = _taggedTemplateLiteral([".remote-doctor__1654009826992-2__st0{fill:#6A9AD6;} .remote-doctor__1654009826992-2__st1{fill:#BDDBFF;}"])));

var RemoteDoctorSvg = function RemoteDoctorSvg(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 56.2 64.3"
    },
    version: "1.1",
    viewBox: "0 0 56.2 64.3",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/_react.default.createElement(Styles, null), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", {
    id: "Group_1349"
  }, /*#__PURE__*/_react.default.createElement("path", {
    className: "remote-doctor__1654009826992-2__st0",
    id: "Path_1509",
    d: "M36.9,0H5.4C2.4,0,0,2.4,0,5.4l0,0v53.5c0,3,2.4,5.4,5.4,5.4h31.5c3,0,5.4-2.4,5.4-5.4V5.4 C42.3,2.4,39.8,0,36.9,0z M40.1,58.9c0,1.8-1.5,3.2-3.2,3.2H5.4c-1.8,0-3.2-1.4-3.2-3.2V5.4c0-1.8,1.4-3.2,3.2-3.2h31.5 c1.8,0,3.2,1.4,3.2,3.2V58.9z M36.9,4.3H5.4c-0.6,0-1.1,0.5-1.1,1.1l0,0v48.1c0,0.6,0.5,1.1,1.1,1.1h31.5c0.6,0,1.1-0.5,1.1-1.1 V5.4C37.9,4.8,37.5,4.3,36.9,4.3z M35.8,52.5H6.5v-46h29.3L35.8,52.5z M24.5,58.3c0,0.6-0.5,1.1-1.1,1.1h-4.6 c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1c0,0,0,0,0,0h4.6C24,57.2,24.5,57.7,24.5,58.3L24.5,58.3z"
  })), /*#__PURE__*/_react.default.createElement("path", {
    className: "remote-doctor__1654009826992-2__st1",
    d: "M55.6,35.6c-1.1-2.2-3.4-3.5-5.7-3.4c-0.3-1.8-0.9-3.6-1.8-5.3c-4.6-9.1-15.6-5.5-15.3,7.4 c0.1,5.5-2.6,9.1-6.1,9.5c-3.2,0.4-5.7-2.1-5.6-6.4c2.4-0.4,4.6-2.2,5.5-5.5c2.2-8.7,2.7-10.4,2.9-12.5c0.3-2.8-0.5-4.3-2.6-4.8 c-0.5-0.1-0.9-0.2-1.4-0.3c-0.7,0-1.2,0.5-1.3,1.1c0,0.6,0.4,1.2,1,1.3c0.4,0,0.7,0.1,1.1,0.2c0.8,0.2,1,0.6,0.8,2.3 c-0.2,1.9-0.6,3.6-2.8,12.1c-1.3,5.2-7.2,5-8.3,0.1c-2.6-11.4-2.6-11.4-2.6-13c-0.1-1.3,0-1.4,1.6-1.6c0.6-0.1,1.1-0.7,1-1.4 c-0.1-0.6-0.7-1.1-1.3-1l0,0c-2.6,0.4-3.7,1.4-3.6,4.1c0.1,1.9,0,1.6,2.7,13.5c0.7,3.3,3,5.1,5.5,5.5c-0.1,5.5,3.3,8.9,7.7,8.4 c4.5-0.6,7.9-5,7.8-11.5c-0.2-10.9,8.1-13.6,11.7-6.5c0.7,1.5,1.3,3.1,1.6,4.7c-0.3,0.1-0.5,0.2-0.8,0.3c-3.1,1.6-4.3,5.4-2.7,8.5 c0,0,0,0,0,0c1.6,3.1,5.3,4.3,8.4,2.8C55.9,42.5,57.1,38.7,55.6,35.6z M51.9,42.2C51.9,42.2,51.9,42.2,51.9,42.2L51.9,42.2 c-2.1,1.1-4.6,0.2-5.6-1.8c-1-2.1-0.2-4.6,1.8-5.7c2-1.1,4.6-0.2,5.6,1.8C54.7,38.7,53.9,41.2,51.9,42.2z"
  })));
};

var _default = RemoteDoctorSvg;
exports.default = _default;